import type { DocumentUploadProgress } from "../documents/client";
import type { DocumentUploadStatus } from "../documents/useDocumentUpload";

// Truthful, phase-aware upload copy for the prescription uploader on the Order Medicines form.
// "uploading" is the only phase with a real, meaningful percentage -- it comes straight from
// useDocumentUpload's XHR byte-progress event (see documents/useDocumentUpload.ts), the same
// unmodified Health Vault upload engine every other document upload already uses. "preparing"
// (requesting the presigned URL) and "finalizing" (calling complete-upload) have no bytes in
// flight, so they are never given a percentage -- inventing one there would not be truthful.
export function describePrescriptionUploadStage(status: DocumentUploadStatus, progress: DocumentUploadProgress | null): string | null {
  switch (status) {
    case "preparing":
      return "Preparing upload…";
    case "uploading":
      return progress?.percentage != null ? `Uploading… ${progress.percentage}%` : "Uploading…";
    case "finalizing":
      return "Finalizing…";
    default:
      return null;
  }
}
